import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { Modal } from "antd";
import { withAuth } from "@salespark/api-client";
import { useAuth } from "services/Auth";
import { createAPIClientAuth } from "utils/helper";
import { subscribeToReconnect } from "utils/networkConnection";
import { downloadAutoSyncData } from "./index";
import SyncBlockingModal from "components/SyncBlockingModal";

const AutoSyncOnReconnect = () => {
  const { auth } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("A sincronizar dados após reconexão...");
  const syncInProgressRef = useRef(false);

  const apiClient = useMemo(() => {
    if (!auth?.data) {
      return null;
    }

    return withAuth(createAPIClientAuth(auth.data));
  }, [auth?.data]);

  const runReconnectSync = useCallback(async () => {
    if (!apiClient || syncInProgressRef.current) {
      return;
    }

    syncInProgressRef.current = true;
    setModalMessage("A sincronizar dados após reconexão...");
    setIsModalOpen(true);

    try {
      const syncResponse = await downloadAutoSyncData({
        apiClient,
        onProgress: (message) => {
          if (typeof message === "string" && message.trim()) {
            setModalMessage(message);
          }
        },
      });

      if (syncResponse.status === false) {
        Modal.error({
          title: "Erro na sincronização",
          content: "Não foi possível concluir a sincronização após a reconexão.",
        });
      }
    } finally {
      setIsModalOpen(false);
      syncInProgressRef.current = false;
    }
  }, [apiClient]);

  useEffect(() => {
    const unsubscribeReconnect = subscribeToReconnect(() => {
      runReconnectSync();
    });

    return unsubscribeReconnect;
  }, [runReconnectSync]);

  return <SyncBlockingModal open={isModalOpen} message={modalMessage} />;
};

export default AutoSyncOnReconnect;
